import { INLINE_STYLE } from "draftail";

const inlineStyles = [
  { type: INLINE_STYLE.BOLD },
  { type: INLINE_STYLE.CODE },
  { type: INLINE_STYLE.UNDERLINE },
  { type: INLINE_STYLE.ITALIC }
];

export default inlineStyles;